<div class="launch-container">
  <h2>Launch Component</h2>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading">
    <p>Loading practitioner data...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error" class="error">
    <p>Error: {{ error }}</p>
  </div>

  <!-- Practitioner Data Display -->
  <div *ngIf="practitionerData && !loading" class="practitioner-data">
    <h3>Practitioner Data</h3>

    <!-- Display as JSON -->
    <pre>{{ practitionerData | json }}</pre>

    <!-- Or display specific fields if it's a Bundle -->
    <div *ngIf="practitionerData.resourceType === 'Bundle'">
      <h4>Found {{ practitionerData.total }} practitioners</h4>

      <div *ngFor="let entry of practitionerData.entry" class="practitioner-card">
        <h5>{{ entry.resource.name?.[0]?.given?.join(' ') }} {{ entry.resource.name?.[0]?.family }}</h5>
        <p><strong>ID:</strong> {{ entry.resource.id }}</p>
        <p><strong>Gender:</strong> {{ entry.resource.gender }}</p>
        <p><strong>Telecom:</strong> {{ entry.resource.telecom?.[0]?.value }}</p>
      </div>
    </div>

    <!-- If it's a single Practitioner resource -->
    <div *ngIf="practitionerData.resourceType === 'Practitioner'" class="practitioner-card">
      <h4>{{ practitionerData.name?.[0]?.given?.join(' ') }} {{ practitionerData.name?.[0]?.family }}</h4>
      <p><strong>ID:</strong> {{ practitionerData.id }}</p>
      <p><strong>Gender:</strong> {{ practitionerData.gender }}</p>
      <p><strong>Telecom:</strong> {{ practitionerData.telecom?.[0]?.value }}</p>
    </div>
  </div>
</div>
